// extracted by mini-css-extract-plugin
module.exports = {"SupplierEnquireModal":"SupplierEnquireModal_SupplierEnquireModal__htvte","tabs":"SupplierEnquireModal_tabs__m7g5H","isActive":"SupplierEnquireModal_isActive__57OOb"};